import type { ComponentProps } from "react"

export default function TransactionFreeSale(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M15.3818 7.29175L15.4639 7.37476C15.5418 7.46214 15.6058 7.56121 15.6533 7.6687C15.7167 7.812 15.7498 7.96709 15.75 8.12378V14.6248C15.7497 14.923 15.6308 15.2088 15.4199 15.4197C15.209 15.6306 14.9233 15.7494 14.625 15.7498H9.53711L12.4434 7.99976H8.38672L10.1943 2.57593L15.3818 7.29175ZM6.05176 8.68335L5.6123 9.99976H9.55664L7.40039 15.7498H3.375C3.07674 15.7494 2.79098 15.6306 2.58008 15.4197C2.36925 15.2088 2.25034 14.923 2.25 14.6248V8.12378C2.25014 7.96707 2.28329 7.81202 2.34668 7.6687C2.41004 7.52553 2.50245 7.3972 2.61816 7.29175L8.20996 2.20679L6.05176 8.68335Z"
        fill={fill}
      />
    </svg>
  )
}
